import { httpFetch, merge } from '@websolutespa/bom-core';
import { ApiRequestOptions, getLocalApiRequestOptions, getLocalApiUrl } from '@websolutespa/bom-mixer-store';

export async function localCollectionFetch<T = unknown>(pathname: string, options: ApiRequestOptions = {}, serviceOptions?: { locale: string, market: string }): Promise<T> {
  const url = new URL(getLocalApiUrl(pathname));
  if (serviceOptions) {
    url.searchParams.append('locale', serviceOptions.locale);
    url.searchParams.append('market', serviceOptions.market);
  }
  const apiOptions = merge({ ...getLocalApiRequestOptions() }, options);
  const apiResponse = await httpFetch(url.href, apiOptions);
  return apiResponse;
}

export async function localCollectionGet<T = unknown>(url: string, options: ApiRequestOptions = {}, serviceOptions?: { locale: string, market: string }): Promise<T> {
  return await localCollectionFetch<T>(url, { ...options, method: 'GET' }, serviceOptions);
}

export async function localCollectionPost<T = unknown>(url: string, payload?: unknown, options: ApiRequestOptions = {}, serviceOptions?: { locale: string, market: string }): Promise<T> {
  return await localCollectionFetch<T>(url, { ...options, method: 'POST', body: payload ? JSON.stringify(payload) : undefined }, serviceOptions);
}

export async function localCollectionPut<T = unknown>(url: string, payload?: unknown, options: ApiRequestOptions = {}, serviceOptions?: { locale: string, market: string }): Promise<T> {
  return await localCollectionFetch<T>(url, { ...options, method: 'PUT', body: payload ? JSON.stringify(payload) : undefined }, serviceOptions);
}

export async function localCollectionPatch<T = unknown>(url: string, payload?: unknown, options: ApiRequestOptions = {}, serviceOptions?: { locale: string, market: string }): Promise<T> {
  return await localCollectionFetch<T>(url, { ...options, method: 'PATCH', body: payload ? JSON.stringify(payload) : undefined }, serviceOptions);
}

export async function localCollectionDelete<T = unknown>(url: string, options: ApiRequestOptions = {}, serviceOptions?: { locale: string, market: string }): Promise<T> {
  return await localCollectionFetch<T>(url, { ...options, method: 'DELETE' }, serviceOptions);
}
